module.exports = __webpack_public_path__ + "img/diners_club_international_logo.f76c09d.png";